export const DEV_MODE = process?.env?.NODE_ENV === 'development'; // todo
export const DEV_TIMING = DEV_MODE && false;
export const DEV_DEBUG_LOCATION = DEV_MODE && false;
export const PREVIEW_MODE = process?.env?.RAZZLE_PREVIEW === '1';


export default DEV_MODE;
